import { Typography, Box, Dialog, DialogTitle, DialogContent } from "@mui/material"
import { useDialog } from "common/DialogProvider"
import DevErrorScreen from "components/common/DevErrorScreen"
import DefaultDialog from "components/Dialog/DefaultDialog"
import React from "react"
import { Component } from "react"

interface ErrorBoundaryState {
  hasError: boolean
  error: Error
  showMessage: boolean
}

interface ErrorBoundaryProps {
  fallback?: React.ReactNode
  children?: React.ReactNode
}

export default class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props) {
    super(props)
    this.state = {
      hasError: false,
      error: null,
      showMessage: true
    }
  }

  static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true,
      error,
    }
  }

  closeMessage = () => {
    this.setState({ showMessage: false })
  }

  render() {
    if (this.state.hasError) {
      if (import.meta.env.DEV) {
        return <DevErrorScreen error={this.state.error} />
      }

      if(!this.props.fallback){
        
        return this.state.showMessage&&<Box className="toast-container top-right" style={{ zIndex: 9999 }}>
          <DefaultDialog
            title="Error"
            message={"An unexpected error occurred."}
            type="error"
            handleClose={this.closeMessage}
            confirmButton={{
                confirmLabel: "Go to Home",
                handleConfirm: () => {
                    window.location.href = "/"
                }
            }}
            cancelButton={{
                cancelLabel: "Retry",
                handleCancel: () => {
                    window.location.reload()
                }
            }}
            />
        </Box>
      }

      return this.props.fallback
    }

    return this.props.children
  }
}